import { Component, OnChanges, Input, EventEmitter, Output, SimpleChange, SimpleChanges } from '@angular/core';
import * as _ from 'lodash';


@Component({
  selector: 'mapfre-auditlib-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent {


  _src: any;
  @Input()
  set src(value) {
    this._src = value;
    this.paginate({ first: 0, rows: this.itemsPerPage });
  }
  get src() {
    return this._src
  }

  @Input()
  itemsPerPage = 5

  _paginatedData;
  @Input()
  get paginatedData() {
    return this._paginatedData
  }
  set paginatedData(value) {
    this._paginatedData = value;
    setTimeout(() => this.paginatedDataChange.emit(this._paginatedData));
  }
  @Output()
  paginatedDataChange = new EventEmitter();

  @Output()
  pageChange = new EventEmitter();

  first

  constructor() { }


  public paginate(event) {
    if (_.isArray(this.src) && !_.isEmpty(this.src)) {
      this.first = event.first;
      let end = event.first + event.rows > this.src.length ? this.src.length : event.first + event.rows
      this.paginatedData = _.slice(this.src, this.first, end);
    } else {
      this.paginatedData = _.stubArray();
    }
    this.pageChange.emit(event.page);
    //event.first = Index of the first record
    //event.rows = Number of rows to display in new page
    //event.page = Index of the new page
    //event.pageCount = Total number of pages
  }

}
